/** @jsx jsx */

import { jsx } from "theme-ui";
import { DefaultButton } from "office-ui-fabric-react";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import { useContext } from "react";
import { formatSys2OdooDate } from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import PropTypes from "prop-types";
import { DynamicFormLang, useLang } from "./LanguageSelector";
import FormContext from "./FormContext";

const { shade4 } = require("./json/colors.json");
const visitForm = require("./json/visit.json");

const today = formatSys2OdooDate(new Date());

function NewStayRecord({ btnNewVisitText, fixedValues }) {
  const { uid, onAddNew } = useContext(FormContext);

  const [open, { setTrue, setFalse }] = useMyBoolean(false);
  const [getLangString] = useLang();

  if (!open) {
    return (
      <DefaultButton
        text={getLangString(btnNewVisitText)}
        iconProps={{ iconName: "Add" }}
        onClick={setTrue}
      />
    );
  }

  return (
    <div sx={{ p: 2, bg: shade4 }}>
      <DynamicFormLang
        formTitle={btnNewVisitText}
        formFields={visitForm.fields.map((f) =>
          f.name in fixedValues ? { ...f } : f
        )}
        saveBtnText="buttons.save"
        formValidator={visitForm.validators}
        defaultValues={{ uid, create_date: today, ...fixedValues }}
        onSubmit={onAddNew}
        onDiscard={setFalse}
      />
    </div>
  );
}

NewStayRecord.propTypes = {
  btnNewVisitText: PropTypes.string,
  fixedValues: PropTypes.shape({}),
};

NewStayRecord.defaultProps = {
  btnNewVisitText: "buttons.add_new_visit",
  fixedValues: {},
};

export default NewStayRecord;
